<div id='manageAuctionPage' class="mt-5 pt-5" #manageAuctionPage>
    <app-header title="Manage Auctions"></app-header>
    <div class="px-4">
        <header>
            <div class="d-flex justify-content-between align-items-center mb-4">   
                <div (click)="navigateByUrl('/manageAuction/list')">
                    <a type="button" 
                    class="body-2"
                    style="
                    cursor: pointer;
                    color: #007bff;
                    "
                    routerLink="/manageAuction/list"
                    >
                    <i class="fas fa-chevron-left mr-1"></i>
                   Auctions
                </a>
                </div>   
                <div class="d-flex justify-content-end flex-column" >
                    <ng-container *ngIf="auction && (isShowPauseCounter || isShowCloseCounter)">
                        <app-counter [campaign]="auction"  [mode]="3"></app-counter>
                    </ng-container>
                    <ul *ngIf = 'auction' class="d-flex flex-row justify-content-end actions-list list-group" style="height: 36px;" >
                        <li (click)="onStopClick(auction)"
                            *ngIf="auction.campaignTypeData.auctionType === 0 && getAuctionStatus() == 1 || auction.campaignTypeData.auctionType === 0 && getAuctionStatus() == 0 " 
                            class="list-group-item d-flex">
                            <i class="fas fa-stop fa-sm disabled pointer" style="color: #ff0512;"></i>
                            <span class="ml-2 pointer expanded-text body-1 ">Close Auction Now...</span>
                        </li>
                        <li class=" ml-3 list-group-item d-flex" 
                            *ngIf="auction.campaignTypeData.auctionType === 0 && auctionStatus !== 2" 
                            (click)="onPauseResumeClick(auction)">
                            <ng-container [ngSwitch]="auctionStatus">
                                <i *ngSwitchCase="1" class="fas fa-play"></i>
                                <i *ngSwitchCase="0" class="fas fa-pause"></i>
                              </ng-container>
                            <span class="ml-1 pointer expanded-text body-1 ">{{auctionStatus == 1 ? 'Start Bidding Now...': 'Stop Bidding Now...'}}</span>
                        </li>
                        <li class="list-group-item list-group-item--auction d-flex ml-3 pointer p-0"
                            (mouseenter)="isDownloadHovered = true" 
                            (mouseleave)="isDownloadHovered = false" >
                            <app-auctions-popover [auction]="auction" class="noDetaisClick">
                                <span *ngIf="isDownloadHovered" class="noDetaisClick ml-1 pointer body-1">Download Reports & Bid Sheets</span>
                              </app-auctions-popover>    
                        </li> 
                    </ul>
                </div>  
            </div>
            <div class="mb-4"  *ngIf="auction">
                <div class="">
                    <div class="align-items-center d-flex">
                        <h1 class="p-0 headline-4 mr-2">{{auction.name}}</h1>
                        <div [innerHTML]="getAuctionStatusHTML()" style="display: contents;"></div>
                    </div>
                    <span class="body-2 d-flex mb-3" style="color: #676767;">Created On {{createdOn}}</span>
                    <div class="d-flex">
                        <div class="d-block">
                            <img *ngIf="auction.imageUrl" [src]= auction.imageUrl alt="Auction Campaign Image" class="img-fluid rounded-start" style="height: 110px; min-width: 220px; border-radius: 4px;">
                            <img *ngIf="!auction.imageUrl" src="/images/org_logo_default_v2.svg" alt="Auction Campaign Image" class="img-fluid rounded-start" style="height: 110px; min-width: 220px; border-radius: 4px;">
                        </div>
                        <div class="d-flex w-100 ml-4">
                            <div class="d-flex flex-column w-100">
                                <div class="row d-flex align-items-center mb-2">
                                    <div class="col-3">
                                        <span class="caption-p2p-leaderboard--text">View Auction</span>
                                    </div>
                                    <div [ngClass]="auction.status === 2 ? 'disabled' : ''" class="col-9 d-flex align-items-center">
                                        <a [href]="auctionLink" class="caption-p2p-leaderboard--link" target="_blank" data-toggle="tooltip" data-placement="top" title="Tap to open in a new tab">{{auctionLink}}</a>
                                        <div (click)="copyLink(auctionLink)" class="d-flex justify-content-center align-items-center copy-link-icon cursor--pointer mx-2">
                                            <i class="far fa-copy p-2"></i>
                                        </div>
                                        <div *ngIf="auction.status === 2" class="campaign__characteristic-value campaign__characteristic-value--red position-relative px-2 py-1" >
                                            <div class="campaign__characteristic-background campaign__characteristic-background--red position-absolute h-100 w-100"></div>
                                            Deactivated
                                        </div>
                                    </div>
                                </div>
                                <div class="row d-flex align-items-center mb-2">
                                    <div class="col-3">
                                        <span class="caption-p2p-leaderboard--text">Auction Slide Show</span>
                                    </div>
                                    <div class="col-9 d-flex align-items-center">
                                        <a [href]="auctionSlideShowLink" class="caption-p2p-leaderboard--link" target="_blank" data-toggle="tooltip" data-placement="top" title="Tap to open in a new tab">{{auctionSlideShowLink}}</a>
                                        <div (click)="copyLink(auctionSlideShowLink)" class="d-flex justify-content-center align-items-center copy-link-icon cursor--pointer ml-2">
                                            <i class="far fa-copy p-2"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <ul class="nav md-tabs md-tabs--paybee paybee-modal-header--regular paybee-modal-header--white-important p-0" role="tablist">
                <li class="nav-item">
                    <a [ngClass]="{'active': activeTab === 'auctions'}" class="nav-link px-3 py-2" id="auctionsTabNav" data-fragment="auctionsTab" href="#auctionsTab" role="tab" aria-controls="auctionsTab"
                       aria-selected="true">Auction Items</a>
                </li>
                <li [ngClass]="{'d-none': auctionType === 1}" class="nav-item">
                    <a (click)="showRemindersPage()" [ngClass]="{'active': activeTab === 'reminders'}" class="nav-link px-3 py-2" id="remindersTabNav" data-fragment="remindersTab" href="#remindersTab" role="tab" aria-controls="remindersTab"
                       aria-selected="true">Reminders</a>
                </li>
                <li  class="nav-item">
                    <a [ngClass]="{'active': activeTab === 'bidActivity'}" class="nav-link px-3 py-2" id="bidActivityTabNav" data-fragment="bidActivityTab" href="#bidActivityTab" role="tab" aria-controls="bidActivityTab"
                       aria-selected="true">Bid Activity</a>
                </li>
                <li  class="nav-item">
                    <a [ngClass]="{'active': activeTab === 'paid'}" class="nav-link px-3 py-2" id="paidTabNav" data-fragment="paidTab" href="#paidTab" role="tab" aria-controls="paidTab"
                       aria-selected="true">Paid</a>
                </li>
                <li  class="nav-item">
                    <a [ngClass]="{'active': activeTab === 'pending'}" class="nav-link px-3 py-2" id="pendingTabNav" data-fragment="pendingTab" href="#pendingTab" role="tab" aria-controls="pendingTab"
                       aria-selected="true">Pending</a>
                </li>
                <li  class="nav-item">
                    <a [ngClass]="{'active': activeTab === 'bidders'}" class="nav-link px-3 py-2" id="biddersTabNav" data-fragment="biddersTab" href="#biddersTab" role="tab" aria-controls="biddersTab"
                       aria-selected="true">Bidders</a>
                </li>
            </ul>            
        </header>

        @if(auction && activeTab === 'auctions'){
            <div class="d-flex justify-content-center">
                <div class="col-8">
                    <div class="d-flex justify-content-between align-items-center mb-1 mt-3">
                        <span class="headline-6" *ngIf="auction">Auction items ({{noDeletedItems.length}})</span>
                        <div class="card__right-side d-flex justify-content-end search">
                            <div class="search__icon-wrapper">
                                <i class="fas fa-search input-prefix"></i>
                            </div>
                            <input [formControl]="itemSearch" class="form-control--search" placeholder="Find Item" />
                            <div class="search__icon-wrapper--cross px-1"><span class="cursor-pointer" *ngIf="itemSearch.value.length > 0" (click)="resetSearch()">X</span></div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between mt-3">
                        <app-auction-items-filter-popover [categoies]="customUserCategories"></app-auction-items-filter-popover>
                        <button (click)="openAuctionDetailModal()" type="button" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light mr-3 shadow-none" aria-expanded="false" style="background-color: #fff;">
                            <i class="fas fa-search input-prefix mx-2"></i>
                            <span class="mr-2 form-control--search cursor-pointer">Bidder Search...</span>
                        </button>
                    </div>
                        <div class="py-5">
                            @for(item of auctionManageService.filteredItems; track item.id){
                                <app-auction-item-card [auctionItem]="item" [auction]="auction"></app-auction-item-card>
                            } @empty{
                                <span class="body-1">No matching items</span>
                            }
                        </div>
                </div>
            </div>
            
        }
        
        
        @if(auction && activeTab === 'reminders'){
            <div class="tab-pane fade show pb-4" id="remindersTab" data-page="scheduleReminder" role="tabpanel" aria-labelledby="remindersTabNav">
                <div class="accordion md-accordion mt-3" style="border:none !important;" id="scheduleReminderAccordion" role="tablist" aria-multiselectable="true">
                    <div class="d-flex align-items-center justify-content-between mb-3">
                        <div class="headline-6 px-3">Reminders</div>
                        <div class="d-flex align-items-center">
                            <div id="eventDateTime" class="body-1 mr-2"></div>
                            <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                <i class="fas fa-paper-plane mr-2"></i>
                                <span class="mr-2">Send Now</span>
                                <i class="fas fa-caret-down"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right">
                                <li [ngClass]="scheduleReminderClassList" (click)="onNotifyAuctionClosingClick(auction)" class="dropdown-item body-1">
                                    <a>Auction Closing...</a>
                                    @if(scheduleReminderClassList.disabled) {
                                        <div class="caption red-text">Auction is closed</div>
                                    }
                                </li>
                                <li
                                    [ngClass]="{ 'disabled': allBidders?.length === 0 }"
                                    (click)="onNotifyAllBiddersClick()" class="dropdown-item body-1"
                                >
                                    <a>Notify All Bidders...</a>
                                </li>
                            </ul>
                            <div id="eventDateTime" class="body-1 mr-2"></div>
                            <div>
                                <button type="button" data-toggle="dropdown" class="btn btn--paybee btn--outline-transparent btn--padding10x15 button btn--solid-border waves-effect waves-light my-0 ml-0 mr-2 shadow-none">
                                    <i class="fas fa-paper-plane mr-2"></i>
                                    <span class="mr-2">Schedule</span>
                                    <i class="fas fa-caret-down"></i>
                                </button>
                                <ul class="dropdown-menu dropdown-menu-right">
                                    @if (scheduleReminderClassList.disabled) {
                                        <li class="dropdown-item body-1 disabled">
                                            <a>Auction Closing...</a>
                                            <div class="caption red-text">Auction is closed</div>
                                        </li>
                                    } @else {
                                        <li data-id="scheduleCustomReminder_4" data-task-type="4" data-action="scheduleCustomReminder" class="dropdown-item body-1">
                                            <a>Auction Closing...</a>
                                        </li>
                                    }
    
                                    @if(allBidders?.length === 0){
                                        <li 
                                            class="dropdown-item body-1 disabled"
                                        >
                                            <a>Notify All Bidders...</a>
                                        </li>
                                    } @else{
                                        <li 
                                            class="dropdown-item body-1"
                                            data-id="scheduleCustomReminder_17"
                                            data-task-type="17" 
                                            data-action="scheduleCustomReminder" 
                                        >
                                            <a>Notify All Bidders...</a>
                                        </li>
                                    }
                                    
                                </ul>
                            </div>
                            
                        </div>
                    </div>

                    <div class="card" data-section="scheduledReminderCard" style="background-color: HSL(225, 40%, 98%);">
                        <div class="card-header px-1" role="tab" id="scheduledReminderHeading" data-section="scheduledReminderHeading">
                            <a id="scheduledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#scheduledReminderCollapse" aria-expanded="false" aria-controls="scheduledReminderCollapse">
                                <span class="headline-6 black-text pl-5 mb-2">Scheduled</span>
                            </a>
                        </div>

                        <div id="scheduledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="scheduledReminderHeading">
                            <div class="card-body pt-0 px-0">
                                <div class="col-12 col-xl-12" id="scheduledListContainer" data-section='scheduledReminderListContainer'></div>
                            </div>
                        </div>
                    </div>

                    <div class="card" data-section="completedReminderCard" style="background-color: HSL(225, 40%, 98%);">
                        <div class="card-header px-1" role="tab" id="completedReminderHeading" data-section="completedReminderHeading">
                            <a id="completedReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#completedReminderCollapse" aria-expanded="false" aria-controls="completedReminderCollapse">
                                <span class="headline-6 black-text pl-5 mb-2">Completed</span>
                            </a>
                        </div>

                        <div id="completedReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="completedReminderHeading">
                            <div class="card-body pt-0 px-0">
                                <div class="col-12 col-xl-12" id="completedListContainer" data-section='completedReminderListContainer'></div>
                            </div>
                        </div>
                    </div>

                    <div class="card" data-section="cancelledReminderCard" style="background-color: HSL(225, 40%, 98%);">
                        <div class="card-header px-1" role="tab" id="cancelledReminderHeading" data-section="cancelledReminderHeading">
                            <a id="cancelledReminderHeadingLink" class="accordion-button--scheduller collapsed" data-toggle="collapse" href="#cancelledReminderCollapse" aria-expanded="false" aria-controls="cancelledReminderCollapse">
                                <span class="headline-6 black-text pl-5 mb-2">Cancelled</span>
                            </a>
                        </div>

                        <div id="cancelledReminderCollapse" class="collapse" role="tabpanel" aria-labelledby="cancelledReminderHeading">
                            <div class="card-body pt-0 px-0">
                                <div class="col-12 col-xl-12" id="cancelledListContainer" data-section='cancelledReminderListContainer'></div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        }

        @if(auction && activeTab === 'bidActivity'){
            <div>
                <app-auction-bid-activity [auction]="auction"></app-auction-bid-activity>
            </div>
        }

        @if(auction && activeTab === 'paid'){
            <div >
                <app-auction-paid-tab [auction]="auction"></app-auction-paid-tab>
            </div>
        }

        @if(auction && activeTab === 'pending'){
            <div>
                <app-auction-pending-tab [auction]="auction"></app-auction-pending-tab>
            </div>
        }

        @if(auction && activeTab === 'bidders'){
            <div>
                <app-auction-bidders-tab [auction]="auction"></app-auction-bidders-tab>
            </div>
        }
    </div>

</div>